/**
 * Communication topics API for Communication Tutor.
 * Uses gateway client with auth/tenant headers.
 */
import { createHttpClient } from '@/api/http';
import { serviceUrls } from '@/config/serviceUrls';

const client = createHttpClient(serviceUrls.learning);

/** Topics from `/v1/learning/topics/for-student` (and teacher list). `topic_id` is the canonical id for tutor APIs. */
export interface CommunicationTopicDTO {
  id?: string;
  topic_id: string;
  title: string;
  description?: string;
  section_id?: string;
  grade?: string;
  created_by_user_id?: string;
  created_at?: string;
  updated_at?: string;
}

export interface TopicCreatePayload {
  title: string;
  description?: string;
  section_id?: string;
  grade?: string;
}

export async function createTopic(payload: TopicCreatePayload): Promise<CommunicationTopicDTO> {
  const res = await client.post('/v1/learning/topics', {
    title: payload.title,
    description: payload.description ?? '',
    section_id: payload.section_id ?? null,
    grade: payload.grade ?? '2',
  });
  return res.data as CommunicationTopicDTO;
}

export async function listTopicsForTeacher(params?: {
  section_id?: string;
  grade?: string;
  limit?: number;
  skip?: number;
}): Promise<{ items: CommunicationTopicDTO[]; total: number; skip: number; limit: number }> {
  const res = await client.get('/v1/learning/topics', { params });
  return res.data;
}

export async function listTopicsForStudent(params?: {
  section_id?: string;
  grade?: string;
  limit?: number;
  skip?: number;
}): Promise<{ items: CommunicationTopicDTO[]; total: number; skip: number; limit: number }> {
  const res = await client.get('/v1/learning/topics/for-student', { params });
  return res.data;
}
